/* Safta Bee - small layout helpers. Added 12 Sep 2026. */
(function () {
  var MIN = 1068;
  function gallery() { return document.querySelector('.product-grid-container > [id^="MediaGallery"]'); }
  function fit() {
    var g = gallery();
    if (!g) return;
    if (window.innerWidth < MIN) { g.style.top = ''; return; }
    var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
    var offset = hdr + 16;
    var h = g.offsetHeight;
    var vh = window.innerHeight;
    g.style.top = (h + offset + 20 > vh) ? Math.round(vh - h - 20) + 'px' : offset + 'px';
  }
  function boot() {
    fit();
    var g = gallery();
    if (g && window.ResizeObserver) { new ResizeObserver(fit).observe(g); }
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();